import { createSlice } from '@reduxjs/toolkit';

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    filters: {
      partner_id: null,
      fromDate: null,
      toDate: null,
    },
    transactionSummary: {
      isLoading: false,
      data: null,
      error: null,
    },
   inboundPayment: {
    isLoading: false,
    data: [],  
    error: null,
  },
  outboundPayment: {
    isLoading: false,
    data: [], 
    error: null,
  },
    kycCount: {
      isLoading: false,
      data: null,
      error: null,
    },
  },
  reducers: {
    // Transaction Summary reducers
    getTransactionSummaryInit(state) {
      state.transactionSummary.isLoading = true;
      state.transactionSummary.error = null;
    },
    getTransactionSummarySuccess(state, action) {
      state.transactionSummary.isLoading = false;
      state.transactionSummary.data = action.payload;
    },
    getTransactionSummaryFailure(state, action) {
      state.transactionSummary.isLoading = false;
      state.transactionSummary.error = action.payload;
    },

    // Inbound Payment reducers
    getInboundPaymentInit(state) {
      state.inboundPayment.isLoading = true;
      state.inboundPayment.error = null;
    },
    getInboundPaymentSuccess(state, action) {
      state.inboundPayment.isLoading = false;
      state.inboundPayment.data = action.payload;
    },
    getInboundPaymentFailure(state, action) {
      state.inboundPayment.isLoading = false;
      state.inboundPayment.error = action.payload;
    },

    // Outbound Payment reducers
    getOutboundPaymentInit(state) {
      state.outboundPayment.isLoading = true;
      state.outboundPayment.error = null;
    },
    getOutboundPaymentSuccess(state, action) {
      state.outboundPayment.isLoading = false;
      state.outboundPayment.data = action.payload;
    },
    getOutboundPaymentFailure(state, action) {
      state.outboundPayment.isLoading = false;
      state.outboundPayment.error = action.payload;
    },

    // KYC Count reducers
    getKycCountInit(state) {
      state.kycCount.isLoading = true;
      state.kycCount.error = null;
    },
    getKycCountSuccess(state, action) {
      state.kycCount.isLoading = false;
      state.kycCount.data = action.payload;
    },
    getKycCountFailure(state, action) {
      state.kycCount.isLoading = false;
      state.kycCount.error = action.payload;
    },

    setDashboardFilters(state, action) {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetDashboardFilters(state) {
      state.filters = {
        partner_id: null,
        fromDate: null,
        toDate: null,
      };
    },
  },
});

export const {
  getTransactionSummaryInit,
  getTransactionSummarySuccess,
  getTransactionSummaryFailure,

  getInboundPaymentInit,
  getInboundPaymentSuccess,
  getInboundPaymentFailure,

  getOutboundPaymentInit,
  getOutboundPaymentSuccess,
  getOutboundPaymentFailure,

  getKycCountInit,
  getKycCountSuccess,
  getKycCountFailure,

  setDashboardFilters,
  resetDashboardFilters,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
